export enum Category {
  Phones = 'phones',
  Tablets = 'tablets',
  Accessories = 'accessories',
}
